import { cloneSubschemaConfig } from '@graphql-tools/delegate';
export function splitMergedTypeEntryPointsTransformer(subschemaConfig) {
    if (!subschemaConfig.merge)
        return [subschemaConfig];
    const maxEntryPoints = Object.values(subschemaConfig.merge).reduce((max, mergedTypeConfig) => {
        var _a, _b;
        return Math.max(max, (_b = (_a = mergedTypeConfig === null || mergedTypeConfig === void 0 ? void 0 : mergedTypeConfig.entryPoints) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0);
    }, 0);
    if (maxEntryPoints === 0)
        return [subschemaConfig];
    const subschemaPermutations = [];
    for (let i = 0; i < maxEntryPoints; i += 1) {
        const subschemaPermutation = cloneSubschemaConfig(subschemaConfig);
        const mergedTypesCopy = subschemaPermutation.merge;
        if (i > 0) {
            subschemaPermutation.merge = Object.create(null);
        }
        Object.keys(mergedTypesCopy).forEach(typeName => {
            var _a, _b, _c;
            const mergedTypeConfig = mergedTypesCopy[typeName];
            const mergedTypeEntryPoint = (_a = mergedTypeConfig === null || mergedTypeConfig === void 0 ? void 0 : mergedTypeConfig.entryPoints) === null || _a === void 0 ? void 0 : _a[i];
            if (mergedTypeEntryPoint) {
                if ((_c = (_b = mergedTypeConfig.selectionSet) !== null && _b !== void 0 ? _b : mergedTypeConfig.fieldName) !== null && _c !== void 0 ? _c : mergedTypeConfig.resolve) {
                    throw new Error(`Merged type ${typeName} may not define entryPoints in addition to selectionSet, fieldName, or resolve`);
                }
                Object.assign(mergedTypeConfig, mergedTypeEntryPoint);
                delete mergedTypeConfig.entryPoints;
                if (i > 0) {
                    delete mergedTypeConfig.canonical;
                    if (mergedTypeConfig.fields != null) {
                        Object.values(mergedTypeConfig.fields).forEach(mergedFieldConfig => {
                            delete mergedFieldConfig.canonical;
                        });
                    }
                }
                subschemaPermutation.merge[typeName] = mergedTypeConfig;
            }
        });
        subschemaPermutations.push(subschemaPermutation);
    }
    return subschemaPermutations;
}
//# sourceMappingURL=splitMergedTypeEntryPointsTransformer.js.map